import { styled } from "@linaria/react";
import { breakpoints } from "@/styles/utils/vars";
import { cssDialog } from "@/ui/Modal/StyledModal";
export const StyledMapInner = /*#__PURE__*/styled('div')({
  name: "StyledMapInner",
  class: "StyledMapInner_skduds0"
});
export const StyledShopMap = /*#__PURE__*/styled('div')({
  name: "StyledShopMap",
  class: "StyledShopMap_s1whu0ad"
});
export const StyledShopsMap = /*#__PURE__*/styled('div')({
  name: "StyledShopsMap",
  class: "StyledShopsMap_s1vkouke"
});

require("./StyledShopsMap.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./StyledShopsMap.tsx");